import { ReactChild } from 'react'
import { Column, Container, Text } from '@smuchile/pkg-unimarc-components'
import {
  BigScreen,
  SmallScreen
} from '@smuchile/pkg-unimarc-components/helpers'
import { NoProductsIcon } from '../NoProducts/NoProducts'

export interface CouponDetailMessageProps {
  action?: ReactChild
  subtitle?: ReactChild
  title?: ReactChild
}

export const CouponDetailMessage = ({
  action,
  subtitle,
  title
}: CouponDetailMessageProps) => {
  return (
    <>
      <Container
        justifyContent='center'
        padding='16px'
      >
        <NoProductsIcon />
      </Container>

      <BigScreen>
        <Column
          alignItems='center'
          gap='8px'
        >
          <Text
            fontSize='5xl'
            fontWeight='bold'
            textAlign='center'
          >
            {title}
          </Text>

          <Text
            fontSize='xl'
            textAlign='center'
          >
            {subtitle}
          </Text>
        </Column>
      </BigScreen>

      <SmallScreen>
        <Column
          alignItems='center'
          gap='8px'
        >
          <Text
            fontWeight='bold'
            textAlign='center'
          >
            {title}
          </Text>

          <Text
            fontSize='sm'
            isFlex={false}
            textAlign='center'
          >
            {subtitle}
          </Text>
        </Column>
      </SmallScreen>

      {action && (
        <Container
          justifyContent='center'
          padding='16px'
        >
          {action}
        </Container>
      )}
    </>
  )
}
